import TextCell from 'components/TextCell';
import type { ManagedDepotsType } from '../..';

interface CellProps {
  rowData: ManagedDepotsType;
}

export default function CityCell({ rowData: { city } }: CellProps) {
  return <TextCell text={city} />;
}
